import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"

export const getPurchaseOrders = async () => {

    const payload = {
        requestID: requestID()
    }

    try {
        const res = axios.post(`${baseURL}warehouses/getPurchaseOrders`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}


export const createPurchaseOrder = async (payload) => {

    try {
        const res = axios.post(`${baseURL}warehouses/createPurchaseOrder`, payload, config)
        console.log(res)
        return res
    } catch (error) {

   return error
    }
}